import { render, staticRenderFns } from "./VFullPage.vue?vue&type=template&id=108b151d&"
import script from "./VFullPage.vue?vue&type=script&lang=js&"
export * from "./VFullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports